// Third-party
import React from 'react';
import { useIntl } from 'react-intl';
import DOMPurify from 'dompurify';

// Utils
import { formatHTMLMessageWithLocale } from './i18n';
import Dictionary from '@/types/dictionary';
import Locale from '@/types/locale';

type Props = {
  id: string;
  values?: Dictionary<string | number>;
  defaultMessage?: string;
  locale?: Locale;
};

const FormattedHTMLMessage = ({ locale, id, values, defaultMessage }: Props) => {
  const intlHook = useIntl();
  const html = locale
    ? formatHTMLMessageWithLocale(id, locale, values, defaultMessage) || ''
    : intlHook.formatMessage({ id, defaultMessage }, values, { ignoreTag: true });
  return <span dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} />;
};

export default FormattedHTMLMessage;
